/*
 * FileName : index.tsx
 * ProjectName : admin
 * Author : <<author>>
 * Created Date: 2024-10-21 16:09:35
 * Description :
 * -----
 * Last Modified: 2024-12-12 18:21:11
 * Modified By :
 * -----
 * Copyright (c) <<year>> <<company>>. All rights reserved.
 */
// eslint-disable-next-line no-use-before-define
import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { TableProps, ColumnType } from 'antd/es/table';
import './index.less';
import { cloneDeep } from 'lodash';

interface ResizableTableProps<T> extends Omit<TableProps<T>, 'columns'> {
    columns: ColumnType<T>[];
}

// 自定义表格组件
const ResizableTable = <T extends Object, > ({ columns, className, ...args }: ResizableTableProps<T>) => {
    const [ newColumns, setNewColumns ] = useState<ColumnType<T>[]|undefined>(columns);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
        e.preventDefault();
        e.stopPropagation();
        if (newColumns) {
            const startX = e.clientX;
            const startWidth = Number(newColumns[index].width) || 150;

            const mouseMove = (moveEvent: MouseEvent) => {
                moveEvent.preventDefault();
                moveEvent.stopPropagation();
                const newWidth = Math.max(10, startWidth + (moveEvent.clientX - startX)); // 最小宽度

                setNewColumns((prevColumns) => {
                    const updatedColumns = prevColumns ? [ ...prevColumns ] : [];

                    updatedColumns[index].width = newWidth;
                    return updatedColumns;
                });
            };

            const handleMouseMove = (et: MouseEvent) => {
                et.preventDefault();
                et.stopPropagation();
                requestAnimationFrame(() => mouseMove(et));
            };

            const handleMouseUp = (ev: MouseEvent) => {
                ev.preventDefault();
                ev.stopPropagation();
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }
    };

    useEffect(() => {
        setNewColumns((prevColumns) => {
            const cloneCol = cloneDeep(columns);

            cloneCol.forEach((v) => {
                const item = prevColumns?.find((it) => it.dataIndex === v.dataIndex && it.title === v.title);


                if (item) {
                    v.width = item.width;
                }
                return v;
            });
            return cloneCol;
        });
    }, [ columns ]);

    return (
        <Table
            className={`resize-table ${className}`}
            columns={newColumns?.map((col, index) => ({
                ...col,
                ellipsis: typeof col?.ellipsis === 'undefined' ? true : col.ellipsis,
                width: col?.width || 150,
                title: (
                    <div className='resize-title' title={col.title as string}>
                        {col.title}
                        <div
                            className='resize-handle'
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleMouseDown(e, index);
                            }}
                        />
                    </div>
                ),
            }))}
            {
                ...args
            }
        />
    );
};

export default ResizableTable;
